module.exports = __webpack_public_path__ + "static/media/Segment.22d72cb8.jpg";